exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bNnIa849ndPtCpWdsvV7J{height:100%;display:flex;flex-direction:column}._3QYz-xN435ZV2kq0R29Mj8{padding:10px;background:#c4cefc;font-size:15px;line-height:19px}.jL8P723-Io85oI8NcoB6k{font-weight:500;margin-bottom:2px}._2RR33jC8cTQwe3tsOUWUSa{padding:10px;font-size:13px;line-height:20px}.pZ1OgfvvyasQ303SMRM-v>span{margin-right:16px}._2WHt_27lXw3oIhOhNJtvyC{font-weight:500;margin-bottom:5px}\n", ""]);

// Exports
exports.locals = {
	"LeftSidebar": "bNnIa849ndPtCpWdsvV7J",
	"routeInfo": "_3QYz-xN435ZV2kq0R29Mj8",
	"routeName": "jL8P723-Io85oI8NcoB6k",
	"metrics": "_2RR33jC8cTQwe3tsOUWUSa",
	"routeMetrics": "pZ1OgfvvyasQ303SMRM-v",
	"title": "_2WHt_27lXw3oIhOhNJtvyC"
};